<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：会员-用户列表-会员等级
  -->
  <el-dialog title="修改" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="昵称" :label-width="formLabelWidth">
        <el-input v-model="form.nickname" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth">
        <el-input v-model="form.mobile" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="推荐人ID" :label-width="formLabelWidth">
        <el-input v-model="form.inviteId" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="推荐人昵称" :label-width="formLabelWidth">
        <el-input v-model="form.inviteName" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="等级A" :label-width="formLabelWidth">
        <el-select v-model="form.agentAGradeId" clearable placeholder="-请选择等级-">
          <el-option v-for="(item,index) in gradeAList" :key="index" :label="item.name" :value="item.gradeId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级A时效" :label-width="formLabelWidth">
        <el-select v-model="form.dateTypeA" clearable placeholder="-请选择时效-">
          <el-option v-for="(item,index) in prescription" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级B1.0" :label-width="formLabelWidth">
        <el-select v-model="form.agentOneGradeId" clearable placeholder="-请选择等级-">
          <el-option v-for="(item,index) in gradeBList1" :key="index" :label="item.name" :value="item.gradeId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级B1.0时效" :label-width="formLabelWidth">
        <el-select v-model="form.dateTypeBOne" clearable placeholder="-请选择时效-">
          <el-option v-for="(item,index) in prescription" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
      <el-form-item label="等级B2.0" :label-width="formLabelWidth">
        <el-select v-model="form.agentGradeId" clearable placeholder="-请选择等级-">
          <el-option v-for="(item,index) in gradeBList2" :key="index" :label="item.name" :value="item.gradeId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="等级B2.0时效" :label-width="formLabelWidth">
        <el-select v-model="form.dateTypeBTow" clearable placeholder="-请选择时效-">
          <el-option v-for="(item,index) in prescription" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        </el-form-item>
      <!--   <el-form-item label="管理员备注" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入管理员备注"></el-input>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        prescription: [{
            label: "半年",
            value: 1
          },
          {
            label: "一年",
            value: 2
          },
          {
            label: "永久",
            value: 3
          }
        ]
      };
    },
    props: ['open_edit', 'form', 'gradeList', 'gradeAList', 'gradeBList1', 'gradeBList2'],
    created() {

      this.dialogVisible = this.open_edit;

    },
    methods: {

      /*修改用户*/
      editUser() {
        let self = this;
        self.loading = true;
        let params = self.form;
        params.wifiSetting = null;
        UserApi.edituser(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        })
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Grade.vue